module.exports = __webpack_public_path__ + "img/scene_10.144bb24d.jpg";